// Env vars are strings, so a bare `=== "true"` silently reads any typo
// ("True", "1", "yes") as false. Reads process.env rather than Bun.env
// because the vite build runs this under Node, where the Bun global
// doesn't exist.
function parseBoolean(name: string, value: string): boolean {
  if (value === "true") return true;
  if (value === "false") return false;
  throw new Error(
    `Environment variable ${name} must be "true" or "false", got "${value}"`
  );
}

// Unset reads as false so stacks provisioned before a flag existed keep
// their old behavior.
export function booleanEnv(name: string): boolean {
  const value = process.env[name];
  if (value === undefined || value === "") return false;
  return parseBoolean(name, value);
}

export function requiredBooleanEnv(name: string): boolean {
  const value = process.env[name];
  if (!value) throw new Error(`Missing required environment variable: ${name}`);
  return parseBoolean(name, value);
}
